const setupRoutes = [
  {
    path: '',
    component: () => import('@/app/shared/layouts/main/Main.vue'),
    children: [
      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: '/setup/console',
        name: 'setupConsole',
        component: () => import('./views/Setup.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'setup' },
            { title: 'console', active: true },
          ],
          pageTitle: 'Console',
          rule: 'editor'
        }
      }
    ]
  }
];

export default setupRoutes;
